import React, { Fragment, useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import logo from "../../assets/images/logo.png";
import { CarContext } from "../../contexts/carProvider";
import { useAuth } from "../../hooks/useAuth";
import styles from "./style.module.css";
import SnapshotCard from "../../components/snapshotCard";

const PrintPDF = ({
  reference,
  data,
  downloadLoading = false,
}) => {
  const [carName, setCarName] = useState("");
  const { auth } = useAuth();
  const { cars } = useContext(CarContext);
  const [screenWidth, setScreenWidth] = useState({ width: window.innerWidth, height: window.innerHeight });
  useEffect(() => {
    const car = cars.find((c) => c._id === auth.currentCar);
    setCarName(car?.name);
  }, [cars, auth.currentCar]);

  useEffect(() => {
    setScreenWidth({ width: window.innerWidth, height: window.innerHeight })
  }, [])
  return ReactDOM.createPortal(
    <Fragment>
      {downloadLoading && (
        <div className={styles.body_print_loader} style={{ width: screenWidth.width, height: screenWidth.height }}>
          <div className={styles.body_print_loader_inner} />
        </div>
      )}
      <div
        className={`${styles.body_print} ${downloadLoading ? styles.body_print_loading : ""
          }`}
        ref={reference}
      >
        <div className={styles.body_print_wrapper}>
          <div className={styles.body_print_head}>
            <div className={styles.bph_logo_car}>
              <div className={styles.bph_logo}>
                <img src={logo} alt="logo" />
              </div>
              <div className={styles.bph_car_name}>{carName}</div>
            </div>
            <div className={styles.bph_title}>Snapshot</div>
            <div className={styles.bph_date_category}>

            </div>
          </div>
          <div className={styles.bph_snapshot}>
            {data.map((snapshot, index) => (
              <SnapshotCard key={index} snapshot={snapshot} customClass={styles.bph_snapshot_card} />
            ))}
          </div>
        </div>
      </div>
    </Fragment>,
    document.body
  );
};

export default PrintPDF;
